var Hs = {

	trim: function(str) {
		var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
		return String(str).replace(rtrim, '');
	}
}